import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { formikValidation, formikinitialvalues } from "../../../../../CommonFunction/common";
import { updateFormData } from "../../../../../Store/FormDataReducer/FormFieldFunctions";
import Button from "../../../Button/Button";
import Input from "../../../Input/Input";
import PortalFooter from "../../../Reactportal/PortalFooter";
import Reactportal from "../../../Reactportal/Reactportal";
import "./AddUserEntrySection.scss";
import { parseTheAdditionInfo } from "../../../../CommonFunction/parseTheAdditionInfo";
const { gql } = require("@apollo/client");

export let SearchCompanies = gql`
  query SearchCompanies($keyword: String!, $Ids: [ID]) {
    searchCompanies(keyword: $keyword, Ids: $Ids) {
      _id
      Unique_Id
      Search_Value
      City
      Company_Code
      GST_Number
    }
  }
`;

export let SearchBranchWithCompanyId = gql`
  query SearchBranchWithCompanyId($keyword: String, $SearchId: ID) {
    SearchBranchWithCompanyId(keyword: $keyword, Company_ID: $SearchId) {
      _id
      Unique_Id
      Search_Value
      Branch_Code
      Company_ID
      City
      Mobile_Number
      GST_Number
    }
  }
`;
export const RolesData = gql`
  query searchRoles($keyword: String! = "") {
    searchRoles(keyword: $keyword) {
      _id
      Unique_Id
      Role
      RoleType
      Search_Value
      Copy_Role_From
      Back_Year_View_Rights
    }
  }
`;
const AddUserEntrySection = ({ fielddata, inputfields, Type, TypeOfPortal, formkey }) => {
  const [toggleState, setToggleState] = useState(false);
  const [fields, setfields] = useState(inputfields);
  const [alldata, setalldata] = useState({});

  useEffect(() => {
    if (fielddata) {
      let arr = [];
      for (var a = 0; a < fields.length; a++) {
        if (fields[a].name === "Sidebyside" || fields[a].name === "Bank details") {
          for (var b = 0; b < fields[a].Subfields.length; b++) {
            arr.push({
              [fields[a].Subfields[b].name]: fielddata[fields[a].Subfields[b].name],
            });
            formik.setFieldValue(fields[a].Subfields[b].name, fielddata[fields[a].Subfields[b].name]);
          }
        } else {
          if (fields[a].name !== "Password") {
            formik.setFieldValue(fields[a].name, fielddata[fields[a].name]);
            arr.push({ [fields[a].name]: fielddata[fields[a].name] });
          }
        }
      }
      let obj = {};
      for (var l = 0; l < arr.length; l++) {
        let temp = arr[l];
        for (var key in temp) {
          obj[key] = temp[key];
        }
      }
      if (obj) {
        setalldata(obj);
      }
    }
  }, [fielddata]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: "Add_FormFieldData",
      payload: { data: alldata, key: Type },
    });
    updateFormData(dispatch, formkey, Type, alldata);
  }, [alldata]);

  const validate = (values) => {
    setalldata((prevData) => {
      if (Object.keys(prevData).length > 0) {
        return { ...prevData, ...values };
      } else {
        return values;
      }
    });
  };
  const formik = useFormik({
    initialValues: formikinitialvalues(inputfields),
    validationSchema: formikValidation(inputfields),
    validate,
    onSubmit: (values) => { },
  });

  return (
    <>
      {fields[0].name === "User_Name" && <p>Login Details</p>}
      <div className="UserEntryContainer">
        <form
          onSubmit={formik.handleSubmit}
          autoComplete="off"
        // className={`${fields[0].name === "Full_Name" ? "singleChild" : ""}`}
        >
          {fields?.map((element) => {
            let e;
            if (element.Additional_Info && element.Additional_Info.trim()) {
              e = parseTheAdditionInfo(element);
            } else {
              e = element;
            }
            if (TypeOfPortal === "Edit" && e.name === "Password") {
              return (
                <>
                  <div key={e.id} className="formChild">
                    <Button action={() => setToggleState(true)} name="gobutton" text="Reset Password" />
                  </div>
                  {toggleState && (
                    <div key={e.id} className="formChild">
                      <Input
                        EMTQuery=""
                        checked={""}
                        InputConfig={e}
                        name={e.name}
                        value={e.value || alldata[e.name]}
                        Section_Type={Type}
                        roleInput={e.name === "Role" ? true : false}
                        label={e.label}
                        type={e.type}
                        modalform={true}
                        Iconinside={true}
                        handleInputChange={(evt) => {
                          formik.handleChange(evt);
                        }}
                        handleBlur={formik.handleBlur}
                        error={formik.errors[e.name]}
                        touched={formik.touched[e.name]}
                        dropdowndata={e.dropdowndata}
                        hasApiCallback={e.hasApiCallback}
                        min={e.min}
                        max={e.max ? e.max : undefined}
                        transactions={true}
                        formkey={formkey}
                      />
                    </div>
                  )}
                </>
              );
            }

            return (
              <>
                {(TypeOfPortal !== "Edit" || e.name !== "Re_Type_Password") && (
                  <div key={e.id} className="formChild">
                    <Input
                      EMTQuery=""
                      checked={""}
                      InputConfig={e}
                      name={e.name}
                      value={e.value || alldata[e.name]}
                      Section_Type={Type}
                      roleInput={e.name === "Role" ? true : false}
                      label={e.label}
                      type={e.type}
                      modalform={true}
                      Iconinside={true}
                      handleInputChange={(evt) => {
                        formik.handleChange(evt);
                      }}
                      handleBlur={formik.handleBlur}
                      error={formik.errors[e.name]}
                      touched={formik.touched[e.name]}
                      dropdowndata={e.dropdowndata}
                      hasApiCallback={e.hasApiCallback}
                      min={e.min}
                      max={e.max ? e.max : undefined}
                      transactions={true}
                      formkey={formkey}
                    />
                  </div>
                )}
              </>
            );
          })}
        </form>
      </div>
      {toggleState && (
        <>
          <Reactportal open={toggleState} onClose={() => setToggleState(false)} TypeOfPortal={"Reset Password"}>
            <div className="passwordContainer">
              <div className="formChild">
                <Input
                  EMTQuery=""
                  checked={""}
                  InputConfig=""
                  name={"Password"}
                  value={alldata["Password"]}
                  Section_Type={Type}
                  roleInput={"Password" === "Role" ? true : false}
                  label={"Password"}
                  type={"password"}
                  modalform={true}
                  Iconinside={true}
                  handleInputChange={(evt) => {
                    formik.handleChange(evt);
                  }}
                  handleBlur={formik.handleBlur}
                  error={formik.errors["Password"]}
                  touched={formik.touched["Password"]}
                  min={0}
                  max={undefined}
                  formkey={formkey}
                />
              </div>
              <div className="formChild">
                <Input
                  EMTQuery=""
                  checked={""}
                  InputConfig=""
                  name={"Re_Type_Password"}
                  value={alldata["Re_Type_Password"]}
                  Section_Type={Type}
                  label={"Re_Type_Password"}
                  type={"password"}
                  modalform={true}
                  Iconinside={true}
                  handleInputChange={(evt) => {
                    formik.handleChange(evt);
                  }}
                  handleBlur={formik.handleBlur}
                  error={formik.errors["Re_Type_Password"]}
                  touched={formik.touched["Re_Type_Password"]}
                  min={0}
                  max={undefined}
                  formkey={formkey}
                />
              </div>
            </div>
            <PortalFooter
              renderContent={() => <></>}
              submitType={"Reset"}
              submitform={() => {
                setToggleState(false);
              }}
              handleformclose={() => {
                setToggleState(false);
                const newValues = { ...formik.values };
                delete newValues.Re_Type_Password;
                delete newValues.Password;
                delete alldata.Password;
                delete alldata.Re_Type_Password;
                setalldata(alldata);
                formik.setValues(newValues);
              }}
            />
          </Reactportal>
        </>
      )}
    </>
  );
};

export default AddUserEntrySection;
